<template>
    <section>
        <Header
                :header_page_data="headerPageData"
        ></Header>
        <DeleteCampaignModal
                :campaign="currentCampaignComputed"
        ></DeleteCampaignModal>
        <DeleteQuestionModal
                :question="questionToDelete"
                :index="indexQuestionToDelete"
        ></DeleteQuestionModal>
        <DeleteAnswerModal
                :answer="answerToDelete"
                :question="questionToDeleteAnswer"
                :index="indexAnswerToDelete"
        ></DeleteAnswerModal>
        <CannotDeleteQuestionAnswerModal>
        </CannotDeleteQuestionAnswerModal>
        <section>
            <div class="container container-app">
                <section class="position-relative campaigns-container mt-5">
                    <h3 class="settings-title mb-4">{{ $t('campaign_settings.title') }}</h3>
                    <div class="row">
                        <div class="col-12">
                            <div class="row">
                                <div class="col-12">
                                    <span class="add-location-title float-left">{{ $t('campaign_settings.campaign_status') }}</span>
                                </div>
                            </div>
                            <div class="row mt-3 mb-2">
                                <div v-if="campaignStatus === true" class="col-4" style="max-width: 80px;">
                                    {{ $t('campaign_settings.active') }}
                                </div>
                                <div v-else class="col-4" style="max-width: 80px;">
                                    {{ $t('campaign_settings.inactive') }}
                                </div>
                                <div class="col-8">
                                    <label class="switch">
                                        <input v-on:change="changeStatus()" type="checkbox" v-model="campaignStatus" :checked="campaignStatus">
                                        <span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="row">
                                <div class="col-12">
                                    <span class="add-location-title float-left">{{ $t('campaign_settings.campaign_name') }}</span>
                                </div>
                            </div>
                            <div class="row mt-3 mb-2">
                                <div v-if="editName == false" class="col-12">
                                    <div class="input-group">
                                        <span class="mr-3"> {{ currentCampaignComputed.name}} </span>
                                        <div class="input-group-append">
                                            <span @click.prevent="editNameFct()" class="edit-save-name margin-top-5 cursor-pointer" id="basic-addon2">{{ $t('campaign_settings.edit_name') }}</span>
                                        </div>
                                    </div>
                                    <div v-if="hasError(errors, 'name')">
                                        <span class="text-danger">{{errors.name[0]}}</span>
                                    </div>
                                </div>
                                <div v-else class="col-12">
                                    <div class="input-group">
                                        <input type="text" class="form-control form-control--canvassing border-bottom" aria-describedby="basic-addon2" v-model="currentCampaignComputed.name">
                                        <div class="input-group-append">
                                            <span @click.prevent="saveName()" class="edit-save-name margin-top-10 cursor-pointer" id="basic-addon2">{{ $t('campaign_settings.save_name') }}</span>
                                        </div>
                                    </div>
                                    <div v-if="hasError(errors, 'name')">
                                        <span class="text-danger">{{errors.name[0]}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="row">
                                <div class="col-12">
                                    <span class="add-location-title float-left mt-3">{{ $t('campaign_settings.campaign_secret') }}</span>
                                </div>
                            </div>
                            <div class="row mt-3 mb-2">
                                <div class="col-12">
                                    <div class="input-group">
                                    <span>
                                        {{ currentCampaignComputed.secret }}
                                    </span>
                                        <div class="input-group-append ml-2">
                                            <span @click.prevent="copyToClipboard(currentCampaignComputed.secret)" class="edit-save-name cursor-pointer margin-top-5" id="basic-addon2">{{ $t('campaign_settings.copy_secret') }}</span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="row">
                                <div class="col-12">
                                    <span class="add-location-title float-left mt-3">{{ $t('campaign_settings.campaign_location') }}</span>
                                </div>
                            </div>
                            <div class="row mt-3 mb-2">
                                <div class="col-12">
                                <span>
                                    {{  (typeof currentCampaignComputed.location != 'undefined' && typeof currentCampaignComputed.location.properties != 'undefined') ? currentCampaignComputed.location.properties.full_address : '' }}
                                </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <h3 class="settings-title mr-3 mb-4 mt-4">{{ $t('campaign_settings.campaign_reception') }}</h3>
                    <div class="row">
                        <div class="col-12">
                            <div class="row">
                                <div class="col-8 margin-top-5">
                                    <label class="container-permanent-confirm note-text"><span class="mandatory-question-label">{{ $t('campaign_settings.mandatory_question') }}</span>
                                        <input v-on:change="changeReceptionMandatory()" type="checkbox" v-model="campaignReceptionMandatory" :checked="campaignReceptionMandatory">
                                        <span :class="campaignReceptionMandatory == true ? 'checkmark-permanent checkmark-permanent-green' : 'checkmark-permanent'"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <h3 class="settings-title mr-3 mb-4 mt-4">{{ $t('campaign_settings.talking_points') }}</h3>
                    <div class="row">
                        <div class="col-12">
                            <div v-for="(question, index) in currentCampaignComputed.questions" class="row mb-4" :key="index">
                                <div class="col-4 pr-0" style="max-width: 120px;">
                                    <span class="question-label">{{(index + 1) + '#' + ' ' + $t('campaign_settings.question')  }}</span>
                                </div>
                                <div class="col-8 pl-0">
                                    <label v-if="typeof question._id != 'undefined'" class="switch">
                                        <input v-on:change="changeStatusQuestion(question)" type="checkbox" v-model="question.is_visible" :checked="question.is_visible">
                                        <span class="slider round"></span>
                                    </label>
                                </div>
                                <div v-if="typeof question._id != 'undefined'" class="col-12">
                                    <input v-on:change="changeQuestionType(question)" type="radio" :id="'single' + index" :name="'is_multiple' + index" value="single" v-model="question.type">
                                    <label class="mr-2" :for="'single' + index"><span></span>{{ $t('campaign_settings.single') }}</label>
                                    <input v-on:change="changeQuestionType(question)" type="radio" :id="'multiple' + index" :name="'is_multiple' + index" value="multiple" v-model="question.type">
                                    <label class="mr-2" :for="'multiple' + index"><span></span>{{ $t('campaign_settings.multiple') }}</label>
                                    <input :disabled="question.answers.length > 1 ? true : false" v-on:change="changeQuestionType(question)" type="radio" :id="'open' + index" :name="'is_multiple' + index" value="open" v-model="question.type">
                                    <label :class="question.answers.length > 1 ? 'mr-2 disabled-option' : 'mr-2'" :for="'open' + index"><span></span>{{ $t('campaign_settings.open') }}</label>
                                </div>
                                <div v-else class="col-12">
                                </div>
                                <div v-if="typeof question.show_edit != 'undefined' && question.show_edit == true && question.type != 'open'" :class="'col-8 mb-3 question-' + question._id">
                                    <input type="text" class="form-control form-control--canvassing border-bottom" v-model="question.text">
                                    <div v-if="hasErrorQuestion(errors, question._id)">
                                        <span class="text-danger">{{errors.questions[question._id][0]}}</span>
                                    </div>
                                </div>
                                <div v-else-if="(typeof question.show_edit == 'undefined' || question.show_edit == false) && question.type != 'open'" :class="'col-8 mb-2 question-' + question._id">
                                    <span class="question-text">{{ question.text }}</span>
                                </div>
                                <div v-if="question.type != 'open'" :class="'col-4 mb-2 question-' + question._id">
                                    <span v-if="typeof question.show_edit != 'undefined' && question.show_edit == true" @click.prevent="hideEditQuestion(question); saveQuestion(question, index);" class="edit-question-name mr-4 cursor-pointer">{{ $t('campaign_settings.save') }}</span>
                                    <span v-else @click.prevent="showEditQuestion(question, index)" class="edit-question-name mr-4 cursor-pointer">{{ $t('campaign_settings.edit') }}</span>
                                    <span @click.prevent="deleteQuestionModal(question, index)" class="delete-question cursor-pointer">{{ $t('campaign_settings.delete') }}</span>
                                </div>
                                <div v-if="question.type != 'open'" :class="'col-12 mb-3 question-' + question._id">
                                    <div v-for="(answer, indexAnswer) in question.answers" class="row w-100" :key="indexAnswer">
                                        <div v-if="typeof answer.show_edit != 'undefined' && answer.show_edit == true" class="col-8">
                                            <input type="text" class="form-control form-control--canvassing border-bottom" v-model="answer.text">
                                            <div v-if="hasErrorAnswer(errors, answer._id)">
                                                <span class="text-danger">{{errors.answers[answer._id][0]}}</span>
                                            </div>
                                        </div>
                                        <div v-else class="col-8">
                                            <span class="answer-text">{{ answer.text }}</span>
                                        </div>
                                        <div class="col-4">
                                            <span v-if="typeof answer.show_edit != 'undefined' && answer.show_edit == true" @click.prevent="hideEditAnswer(answer); saveAnswer(answer, question, index, indexAnswer);" class="edit-question-name margin-left-20-px mr-4 cursor-pointer">{{ $t('campaign_settings.save') }}</span>
                                            <span v-else @click.prevent="showEditAnswer(answer, index, indexAnswer)" class="edit-question-name margin-left-20-px mr-4 cursor-pointer">{{ $t('campaign_settings.edit') }}</span>
                                            <span @click.prevent="deleteAnswerModal(answer, question, indexAnswer)" class="delete-question cursor-pointer">{{ $t('campaign_settings.delete') }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="question.type != 'open'" :class="'col-12 mb-2 question-'+ question._id">
                                    <span v-if="typeof question.answers != 'undefined'" @click.prevent="addAnswer(question, indexAnswer, index)" class="edit-question-name mr-2 cursor-pointer">{{ $t('campaign_settings.add_answer') }}</span>
                                </div>

                                <div v-if="typeof question.show_edit != 'undefined' && question.show_edit == true && question.type == 'open'" :class="'col-8 mb-3 free-question-' + question._id">
                                    <input type="text" class="form-control form-control--canvassing border-bottom" v-model="question.text">
                                    <div v-if="hasErrorQuestion(errors, question._id)">
                                        <span class="text-danger">{{errors.questions[question._id][0]}}</span>
                                    </div>
                                </div>
                                <div v-else-if="(typeof question.show_edit == 'undefined' || question.show_edit == false) && question.type == 'open'" :class="'col-8 mb-2 free-question-' + question._id">
                                    <span class="question-text">{{ question.text }}</span>
                                </div>
                                <div v-if="question.type == 'open'" :class="'col-4 mb-2 free-question-' + question._id">
                                    <span v-if="typeof question.show_edit != 'undefined' && question.show_edit == true" @click.prevent="hideEditQuestion(question); saveQuestion(question, index);" class="edit-question-name mr-4 cursor-pointer">{{ $t('campaign_settings.save') }}</span>
                                    <span v-else @click.prevent="showEditQuestion(question, index)" class="edit-question-name mr-4 cursor-pointer">{{ $t('campaign_settings.edit') }}</span>
                                    <span @click.prevent="deleteQuestionModal(question, index)" class="delete-question cursor-pointer">{{ $t('campaign_settings.delete') }}</span>
                                </div>

                                <!--- <div v-if="question.type == 'open'" :class="'col-8 mb-2 free-question-' + question._id"> --->
                                <div :class="'col-8 mb-2 free-question-' + question._id">
                                    <span class="question-validation">{{ $t('campaign_settings.fill_and_validation') }}</span>
                                </div>
                               <!--- </div> --->
                                <div v-if="question.type == 'open'" :class="'col-12 free-question-' + question._id">
                                    <input v-on:change="changeQuestionValidation(question)" type="radio" :id="'none' + index" :name="'validation' + index" value="none" v-model="question.validation">
                                    <label class="mr-2" :for="'none' + index"><span></span>{{ $t('campaign_settings.validation_none') }}</label>
                                    <input v-on:change="changeQuestionValidation(question)" type="radio" :id="'email' + index" :name="'validation' + index" value="email" v-model="question.validation">
                                    <label class="mr-2" :for="'email' + index"><span></span>{{ $t('campaign_settings.validation_email') }}</label>
                                    <input v-on:change="changeQuestionValidation(question)" type="radio" :id="'integer' + index" :name="'validation' + index" value="integer" v-model="question.validation">
                                    <label class="mr-2" :for="'integer' + index"><span></span>{{ $t('campaign_settings.validation_number') }}</label>
                                </div>
                                <!--- <div v-if="question.type == 'open'" class="col-8 margin-top-5"> --->
                                <div class="col-8 margin-top-5">
                                    <label class="container-permanent-confirm note-text"><span class="mandatory-question-label">{{ $t('campaign_settings.mandatory_question') }}</span>
                                        <input v-on:change="isMandatoryQuestion(question)" type="checkbox" v-model="question.is_mandatory" :checked="question.is_mandatory">
                                        <span :class="question.is_mandatory == true ? 'checkmark-permanent checkmark-permanent-green' : 'checkmark-permanent'"></span>
                                    </label>
                                </div>
                                <!--- </div> --->
                            </div>
                            <div class="row mb-5">
                                <div class="col-12">
                                    <span @click.prevent="addQuestion" class="edit-question-name mr-2 cursor-pointer">{{ $t('campaign_settings.add_question') }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <button @click.prevent="goto('campaign-map', {campaign_id: currentCampaignComputed._id, campaign: currentCampaignComputed})" class="btn shadow btn-app btn-block primaryBackground">{{ $t('campaign_settings.back_to_map') }}</button>
                        </div>
                    </div>
                    <div class="row modal-footer-canvassing-redish mt-5">
                        <div class="col-12 mt-4 mb-4 d-flex">
                            <span data-toggle="modal" data-target="#deleteCampaignModal" class="modal-footer-canvassing-red-button mx-auto cursor-pointer">{{ $t('campaign_settings.delete_campaign') }}</span>
                        </div>
                        <div class="col-12 text-center mb-2">
                            <p class="note-text">{{ $t('campaign_settings.note_delete') }}</p>
                        </div>
                    </div>
                </section>
            </div>
        </section>
    </section>
</template>

<script>
    import Header from "../layouts/Header";
    import DeleteCampaignModal from "../modals/DeleteCampaignModal";
    import DeleteQuestionModal from "../modals/DeleteQuestionModal";
    import DeleteAnswerModal from "../modals/DeleteAnswerModal";
    import CannotDeleteQuestionAnswerModal from "../modals/CannotDeleteQuestionAnswerModal";
    import HelperMixin from "../../mixins/HelperMixin";

    export default {
        name: "CampaignSettings",
        components: {
            Header, DeleteCampaignModal, 
            DeleteQuestionModal, DeleteAnswerModal,
            CannotDeleteQuestionAnswerModal
        },
        mixins: [HelperMixin],
        props: ['campaign'],
        data() {
            return {
                answerToDelete: null,
                questionToDeleteAnswer: null,
                indexAnswerToDelete: null,
                questionToDelete: null,
                indexQuestionToDelete: null,
                questionsTmp: [],
                errors: {
                    name: [],
                    questions: {},
                    answers: {}
                },
                editName: false,
                campaignStatus: true,
                campaignReceptionMandatory: false,
                headerPageData: {
                    title: this.$store.getters["currentCampaign"].name,
                    search: {
                        show: false,
                        type_search: ''
                    },
                    settings: {
                        show: true,
                        campaign: this.$store.getters["currentCampaign"]
                    },
                    home: {
                        show: true,
                        goto: 'campaign-map'
                    },
                    profile: {
                        show: false
                    }
                }
            }
        },
        created() {
            if (typeof this.currentCampaignComputed.questions != 'undefined') {
                this.questionsTmp = JSON.parse(JSON.stringify(this.currentCampaignComputed.questions));
            }
            this.refreshCampaignSettings();
        },
        computed: {
            currentCampaignComputed() {
                this.campaignStatus = this.$store.getters["currentCampaign"].status == 'active' ? true : false;
                this.campaignReceptionMandatory = this.$store.getters["currentCampaign"].reception_mandatory == true ? true : false;
                return this.$store.getters["currentCampaign"];
            }
        },
        methods: {
            hasErrorQuestion(errors, question_id) {
                if (typeof errors.questions[question_id] != 'undefined') {
                    return true;
                } else {
                    return false;
                }
            },

            hasErrorAnswer(errors, answer_id) {
                if (typeof errors.answers[answer_id] != 'undefined') {
                    return true;
                } else {
                    return false;
                }
            },

            editNameFct() {
                this.editName = true;
            },

            saveName() {
                this.errors.name = [];
                this.$store.dispatch('saveIsLoading', {
                    isLoading: true
                });

                let config = {
                    headers: {
                        'Authorization': `Bearer ${this.$store.getters["token"]}`,
                    }
                };
                this.editName = false;
                axios.post(
                    '/api/v1/campaign/' +  this.currentCampaignComputed._id + '/update',
                    {
                        name: this.currentCampaignComputed.name
                    },
                    config
                ).then(this.consumeDefault, this.errorDefault);
            },

            changeStatus() {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: true
                });

                let config = {
                    headers: {
                        'Authorization': `Bearer ${this.$store.getters["token"]}`,
                    }
                };

                axios.post(
                    '/api/v1/campaign/' +  this.currentCampaignComputed._id + '/update',
                    {
                        status: this.campaignStatus == true ? 'active' : 'inactive'
                    },
                    config
                ).then(this.consumeDefault, this.errorDefault);
            },

            changeReceptionMandatory() {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: true
                });

                let config = {
                    headers: {
                        'Authorization': `Bearer ${this.$store.getters["token"]}`,
                    }
                };

                axios.post(
                    '/api/v1/campaign/' +  this.currentCampaignComputed._id + '/update',
                    {
                        reception_mandatory: this.campaignReceptionMandatory == true ? true : false
                    },
                    config
                ).then(this.consumeDefault, this.errorDefault);

            },

            addQuestion() {
                this.currentCampaignComputed.questions = JSON.parse(JSON.stringify(this.questionsTmp));
                this.currentCampaignComputed.questions.push({text: '', type: 'single', show_edit: true});
            },

            addAnswer(question, indexA, indexQ) {
                this.currentCampaignComputed.questions = JSON.parse(JSON.stringify(this.questionsTmp));
                this.currentCampaignComputed.questions[indexQ].answers.push({text: '', show_edit: true});
            },

            refreshCampaignSettings() {
                if (this.$store.getters["user"] === null) {
                    if (typeof this.$store.getters["token"] == 'undefined') {
                        this.$router.replace({ name: "login"});
                    }
                    this.refreshData();
                }
            },

            changeQuestionType(question) {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: true
                });

                let config = {
                    headers: {
                        'Authorization': `Bearer ${this.$store.getters["token"]}`,
                    }
                };

                axios.post(
                    '/api/v1/campaign/' + this.currentCampaignComputed._id + '/question/' + question._id + '/update',
                    {
                        type: question.type
                    },
                    config
                ).then(this.consumeDefault, this.errorDefault);
            },

            changeQuestionValidation(question) {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: true
                });

                let config = {
                    headers: {
                        'Authorization': `Bearer ${this.$store.getters["token"]}`,
                    }
                };

                axios.post(
                    '/api/v1/campaign/' + this.currentCampaignComputed._id + '/question/' + question._id + '/update',
                    {
                        validation: question.validation
                    },
                    config
                ).then(this.consumeDefault, this.errorDefault);
            },

            isMandatoryQuestion(question) {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: true
                });

                let config = {
                    headers: {
                        'Authorization': `Bearer ${this.$store.getters["token"]}`,
                    }
                };

                axios.post(
                    '/api/v1/campaign/' + this.currentCampaignComputed._id + '/question/' + question._id + '/update',
                    {
                        is_mandatory: question.is_mandatory == true ? 'true' : 'false'
                    },
                    config
                ).then(this.consumeDefault, this.errorDefault);

            },

            deleteAnswerModal(answer, question, index = null) {
                this.answerToDelete = answer;
                this.questionToDeleteAnswer = question;
                this.indexAnswerToDelete = index;
                this.$store.dispatch('saveIsLoading', {
                    isLoading: true
                });

                let config = {
                    headers: {
                        'Authorization': `Bearer ${this.$store.getters["token"]}`,
                    }
                };

                axios.post(
                    '/api/v1/campaign/' + this.currentCampaignComputed._id + '/question/' + question._id + '/answer/' + answer._id + '/check',
                    {},
                    config
                ).then(this.consumeCheckAnswer, this.errorCheckAnswer);

                
            },

            consumeCheckAnswer: function (response) {
                console.log(response);
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
                if (response.data.data == true) {
                    this.answerToDelete = null;
                    this.questionToDeleteAnswer = null;
                    this.indexAnswerToDelete = null;
                    $('#cannotDeleteQuestionAnswerModal').modal('show');
                } else {
                    $('#deleteAnswerModal').modal('show');
                }
                
            },

            errorCheckAnswer: function (error) {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
                console.log(error);
            },

            deleteAnswer(answer, question, index = null) {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: true
                });

                if (typeof answer._id == 'undefined') {
                    question.answers.splice(index, 1);
                    this.$store.dispatch('saveIsLoading', {
                        isLoading: false
                    });
                } else {
                    let config = {
                        headers: {
                            'Authorization': `Bearer ${this.$store.getters["token"]}`,
                        }
                    };

                    axios.post(
                        '/api/v1/campaign/' + this.currentCampaignComputed._id + '/question/' + question._id + '/answer/' + answer._id + '/delete',
                        {},
                        config
                    ).then(this.consumeDefault, this.errorDefault);
                }
            },

            deleteQuestionModal(question, index = null) {
                this.questionToDelete = question;
                this.indexQuestionToDelete = index;
                this.$store.dispatch('saveIsLoading', {
                    isLoading: true
                });

                let config = {
                    headers: {
                        'Authorization': `Bearer ${this.$store.getters["token"]}`,
                    }
                };

                axios.post(
                    '/api/v1/campaign/'  + this.currentCampaignComputed._id +  '/question/' + question._id + '/check',
                    {},
                    config
                ).then(this.consumeCheckQuestion, this.errorCheckQuestion);
                
            },

            consumeCheckQuestion: function (response) {
                console.log(response);
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
                if (response.data.data == true) {
                    this.questionToDelete = null;
                    this.indexQuestionToDelete = null;
                    $('#cannotDeleteQuestionAnswerModal').modal('show');
                } else {
                    $('#deleteQuestionModal').modal('show');
                }
                
            },

            errorCheckQuestion: function (error) {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
                console.log(error);
            },

            deleteQuestion(question, index = null) {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: true
                });

                if (typeof question._id == 'undefined') {
                    this.currentCampaignComputed.questions.splice(index, 1);
                    this.$store.dispatch('saveIsLoading', {
                        isLoading: false
                    });
                } else {
                    let config = {
                        headers: {
                            'Authorization': `Bearer ${this.$store.getters["token"]}`,
                        }
                    };

                    axios.post(
                        '/api/v1/campaign/'  + this.currentCampaignComputed._id +  '/question/' + question._id + '/delete',
                        {},
                        config
                    ).then(this.consumeDefault, this.errorDefault);
                }
            },

            saveAnswer(answer, question, indexQ, indexA) {
                this.errors.answers = {};
                if (answer.text == '') {
                    if (typeof answer._id == 'undefined') {
                        this.errors.answers[answer._id] = [this.$t('campaign_settings.errors.answer_required')];
                        this.showEditAnswer(answer, indexQ, indexA, true);
                        return false;
                    }
                    this.errors.answers[answer._id] = [this.$t('campaign_settings.errors.answer_required')];
                    this.showEditAnswer(answer, indexQ, indexA);
                    return false;
                }
                if (answer.text.length < 2) {
                    if (typeof answer._id == 'undefined') {
                        this.errors.answers[answer._id] = [this.$t('campaign_settings.errors.answer_min')];
                        this.showEditAnswer(answer, indexQ, indexA, true);
                        return false;
                    }
                    this.errors.answers[answer._id] = [this.$t('campaign_settings.errors.answer_min')];
                    this.showEditAnswer(answer, indexQ, indexA);
                    return false;
                }
                if (answer.text.length > 500) {
                    if (typeof answer._id == 'undefined') {
                        this.errors.answers[answer._id] = [this.$t('campaign_settings.errors.answer_max')];
                        this.showEditAnswer(answer, indexQ, indexA, true);
                        return false;
                    }
                    this.errors.answers[answer._id] = [this.$t('campaign_settings.errors.answer_max')];
                    this.showEditAnswer(answer, indexQ, indexA);
                    return false;
                }
                this.$store.dispatch('saveIsLoading', {
                    isLoading: true
                });

                let config = {
                    headers: {
                        'Authorization': `Bearer ${this.$store.getters["token"]}`,
                    }
                };

                let url = typeof answer._id != 'undefined' ? '/api/v1/campaign/' + this.currentCampaignComputed._id + '/question/' + question._id + '/answer/' + answer._id + '/update' : '/api/v1/campaign/' + this.currentCampaignComputed._id + '/question/' + question._id + '/answer/create';
                axios.post(
                    url,
                    {
                        text: answer.text
                    },
                    config
                ).then(this.consumeDefault, this.errorDefault);
            },

            showEditAnswer(answer, indexQ, indexA, newA = false) {
                this.currentCampaignComputed.questions = JSON.parse(JSON.stringify(this.questionsTmp));
                if (newA) {
                    this.currentCampaignComputed.questions[indexQ].answers.push({text: '', type: 'single', show_edit: true});
                } else {
                    this.currentCampaignComputed.questions[indexQ].answers[indexA].show_edit = true;
                }
                answer.show_edit = true;
                this.$forceUpdate();
            },

            hideEditAnswer(answer) {
                answer.show_edit = false;
                this.$forceUpdate();
            },

            saveQuestion(question, indexQ) {
                this.errors.questions = {};
                if (question.text == '') {
                    if (typeof question._id == 'undefined') {
                        this.errors.questions[question._id] = [this.$t('campaign_settings.errors.question_required')];
                        this.showEditQuestion(question, indexQ, true);
                        return false;
                    }
                    this.errors.questions[question._id] = [this.$t('campaign_settings.errors.question_required')];
                    this.showEditQuestion(question, indexQ);
                    return false;
                }
                if (question.text.length < 2) {
                    if (typeof question._id == 'undefined') {
                        this.errors.questions[question._id] = [this.$t('campaign_settings.errors.question_min')];
                        this.showEditQuestion(question, indexQ, true);
                        return false;
                    }
                    this.errors.questions[question._id] = [this.$t('campaign_settings.errors.question_min')];
                    this.showEditQuestion(question, indexQ);
                    return false;
                }
                if (question.text.length > 500) {
                    if (typeof question._id == 'undefined') {
                        this.errors.questions[question._id] = [this.$t('campaign_settings.errors.question_max')];
                        this.showEditQuestion(question, indexQ, true);
                        return false;
                    }
                    this.errors.questions[question._id] = [this.$t('campaign_settings.errors.question_max')];
                    this.showEditQuestion(question, indexQ);
                    return false;
                }
                var url = '';
                var data = {};
                if (typeof question._id == 'undefined') {
                    var url = '/api/v1/campaign/' + this.currentCampaignComputed._id + '/question/create'
                    data = {text: question.text, is_active: true, type: 'single'};
                } else {
                    var url = '/api/v1/campaign/' + this.currentCampaignComputed._id + '/question/' + question._id + '/update';
                    data = {text: question.text};
                }
                this.$store.dispatch('saveIsLoading', {
                    isLoading: true
                });

                let config = {
                    headers: {
                        'Authorization': `Bearer ${this.$store.getters["token"]}`,
                    }
                };

                axios.post(
                    url,
                    data,
                    config
                ).then(this.consumeDefault, this.errorDefault);
            },

            showEditQuestion(question, indexQ, newQ = false) {
                this.currentCampaignComputed.questions = JSON.parse(JSON.stringify(this.questionsTmp));
                if (newQ) {
                    this.currentCampaignComputed.questions.push({text: '', type: 'single', show_edit: true});
                } else {
                    this.currentCampaignComputed.questions[indexQ].show_edit = true;
                }
                this.$forceUpdate();
            },

            hideEditQuestion(question) {
                question.show_edit = false;
                this.$forceUpdate();
            },

            changeStatusQuestion(question) {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: true
                });

                let config = {
                    headers: {
                        'Authorization': `Bearer ${this.$store.getters["token"]}`,
                    }
                };

                axios.post(
                    '/api/v1/campaign/' + this.currentCampaignComputed._id + '/question/' + question._id + '/update',
                    {
                        is_visible: question.is_visible.toString()
                    },
                    config
                ).then(this.consumeDefault, this.errorDefault);
            },

            consumeDefault: function (response) {
                this.questionToDelete = null;
                this.indexQuestionToDelete = null;
                this.answerToDelete = null;
                this.questionToDeleteAnswer = null;
                this.indexAnswerToDelete = null;
                $('#deleteQuestionModal').modal('hide');
                $('#deleteAnswerModal').modal('hide');
                this.errors.answers = {};
                this.errors.questions = {};
                this.errors.name = [];
                this.$store.dispatch('saveCurrentCampaign', {
                    currentCampaign: response.data.data
                });
                this.refreshData();
                this.$forceUpdate();
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
            },

            errorDefault: function (error) {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
                if (
                    error.response !== undefined &&
                    error.response.data !== undefined &&
                    error.response.data.responseType === 'Error' &&
                    error.response.data.errorMessage !== undefined
                ) {
                    if (typeof error.response.data.errorMessage.validation_fail != 'undefined') {
                        if (typeof error.response.data.errorMessage.validation_fail.name != 'undefined') {
                            if (error.response.data.errorMessage.validation_fail.name.includes("required_without")) {
                                this.errors.name = [this.$t('campaign_settings.errors.name_required_without')];
                            }
                            if (error.response.data.errorMessage.validation_fail.name.includes("min")) {
                                this.errors.name = [this.$t('campaign_settings.errors.name_min')];
                            }
                            if (error.response.data.errorMessage.validation_fail.name.includes("max")) {
                                this.errors.name = [this.$t('campaign_settings.errors.name_max')];
                            }
                        }
                    }
                }
                console.log(error);
            },
        },
    };
</script>
